import { vservice } from '@niknevis/vue-modules'
import { AdminTicketRoute } from '@/modules/ticket/routes/admin-ticket.route'
import { Inertia } from '@/modules/shared/helpers/http/facades/inertia'
import { TicketStoreRequestModelInAdmin, TicketUpdateRequestModel } from '@/modules/ticket/models/ticket-request.model'

@vservice()
export class AdminTicketService {
  constructor(
    private readonly routes: AdminTicketRoute
  ) {
  }

  store(data: TicketStoreRequestModelInAdmin) {
    return Inertia.post(
      this.routes.store(),
      data
    )
  }

  update(id: number, data: TicketUpdateRequestModel) {
    return Inertia.put(
      this.routes.update(id),
      data,
      { preserveScroll: true }
    )
  }

}